import { Injectable } from '@angular/core';
import { MktCoopActionFilters } from '../models/mkt-coop-action';

@Injectable({
  providedIn: 'root'
})
export class MktCoopFilterService {

  private _filter: MktCoopActionFilters = new MktCoopActionFilters();

  constructor() { }


  get filter(): MktCoopActionFilters {
    return this._filter;
  }


  set filter(valor: MktCoopActionFilters) {
    this._filter = valor;
  }
}